import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import useGcpsUIController from "@/hooks/useGlobalContext";

export function SiteHeader({ title }: { title?: string | React.ReactNode }) {
	const { controller } = useGcpsUIController();
	const { pageTitle } = controller;

	return (
		<header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
			<div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
				<SidebarTrigger className="-ml-1" />
				<Separator
					orientation="vertical"
					className="mx-2 data-[orientation=vertical]:h-8"
				/>
				<h1 className="text-base font-medium">
					{title || pageTitle}
				</h1>
				<div className="ml-auto flex items-center gap-2">
					<Button variant="ghost" asChild size="sm" className="hidden sm:flex">
						<a
							href="https://gcps.edu.gh"
							rel="noopener noreferrer"
							target="_blank"
							className="dark:text-foreground"
						>
							Main Website
						</a>
					</Button>
				</div>
			</div>
		</header>
	)
}
